import React, { useCallback, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { api } from '../api';
import { showError } from '../toast';
import { Card, COLORS, Muted, Screen, Title } from '../ui';
import { cityLabel } from '../geo';
import { t } from '../i18n';

export default function ConversationsScreen({ navigation }: any) {
  const [conversations, setConversations] = useState<any[]>([]);

  useFocusEffect(
    useCallback(() => {
      api('/listings/conversations').then((r) => setConversations(r.conversations)).catch((e) => showError(e.message));
    }, [])
  );

  return (
    <Screen>
      <Title>{t('Съобщения')}</Title>
      {conversations.length === 0 && (
        <Card>
          <Muted>{t('Няма разговори. Те започват от обявите в „Свободни апартаменти“.')}</Muted>
        </Card>
      )}
      {conversations.map((c) => (
        <Pressable
          key={c.id}
          onPress={() => navigation.navigate('Chat', { conversationId: c.id, listingId: c.listing.id, title: c.listing.title })}
        >
          <Card>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ fontWeight: '600', color: COLORS.text, flex: 1 }}>{c.listing.title}</Text>
              <Muted>{cityLabel(c.listing.city, c.listing.region)}</Muted>
            </View>
            <Muted>{t('С: {name}', { name: `${c.tenant.firstName} ${c.tenant.lastName}` })}</Muted>
            {c.messages[0] && (
              <Text style={{ color: COLORS.muted, marginTop: 4 }} numberOfLines={1}>
                {c.messages[0].text}
              </Text>
            )}
          </Card>
        </Pressable>
      ))}
    </Screen>
  );
}
